<template>
  <v-select label="Etapa do projeto" item-text="name" item-value="Id" :items="etapas" :value="Id"
            v-model="projeto.etapa">
  </v-select>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "SelectProjectStep",
    computed: mapGetters(['projeto']),
    data() {
      return {
          etapas: [{ Id: 1, name: 'Em Negociação' }, { Id: 2, name: 'Aguardando Concessionária' }, { Id: 3, name: 'Pedidos Efetivados' }, { Id: 0, name: 'Projetos Concluído' }]
      }
    }
  }
</script>

<style scoped>

</style>
